<template>
  <div class="common-timeline__wrap p-top-120-80 p-bot-120-80">
    <div class="common-timeline">
      <div class="common-timeline__headings row-240-16 text-center">
        <!-- Timeline Headings -->
        <div
          v-if="props.data.title"
          class="title-l-1 common-timeline__title is-text-center"
          v-html="props.data.title"
        />
      </div>

      <!-- Timeline Scroll Horizontal -->
      <div class="common-timeline__list m-top-32px">
        <WidgetScrollHorizontalSection :items="props.data.timelineList" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagesCommonTimeline',
}
</script>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<style lang="scss">
@import './style.scss';
</style>
